<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 3: Additional Request #3 (Optional)
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <d-field label="Type of Recipient" class="w-full">
        <d-select v-model="thirdAdditionalTypeOfRecipient" expanded>
          <option value="" />
          <option value=" Architect">
            Architect
          </option>
          <option value="General Contractor">
            General Contractor
          </option>
          <option value="Dealer/Other">
            Dealer/Other
          </option>
        </d-select>
      </d-field>

      <div class="flex flex-wrap -mx-5">
        <d-field label="Contact Title" class="w-full md:w-2/12 px-5">
          <d-select v-model="thirdAdditionalContactTitle" expanded>
            <option value="" />
            <option value="Mr">
              Mr
            </option>
            <option value="Mrs">
              Mrs
            </option>
            <option value="Ms">
              Ms
            </option>
          </d-select>
        </d-field>
        <d-field label="Contact First Name" class="w-full md:w-5/12 px-5">
          <d-input v-model="thirdAdditionalFirstName" aria-label="first name" />
        </d-field>
        <d-field label="Contact Last Name" class="w-full md:w-5/12 px-5">
          <d-input v-model="thirdAdditionalContactLastName" aria-label="last name" />
        </d-field>
        <d-field label="Company Name" class="w-full  px-5">
          <d-input v-model="thirdAdditionalCompanyName" aria-label="Company name" />
        </d-field>
        <d-field label="Address Line 1" class="w-full px-5">
          <d-input v-model="thirdAdditionalAddressLineOne" aria-label="Address line 1" />
        </d-field>
        <d-field label="Address Line 2" class="w-full px-5">
          <d-input v-model="thirdAdditionalAddressLineTwo" aria-label="Address Line 2" />
        </d-field>
        <d-field label="City" class="w-full md:w-1/2  px-5">
          <d-input v-model="thirdAdditionalCompanyCity" aria-label="City" />
        </d-field>
        <d-field label="Zip/Postal" class="w-full md:w-1/2 px-5">
          <d-input v-model="thirdAdditionalCompanyZip" aria-label="Zip code" />
        </d-field>
        <d-field label="Country" class="w-full md:w-1/2 px-5">
          <d-select v-model="thirdAdditionalCompanyCountry" expanded required>
            <option value="" disabled>
              Select a Country
            </option>
            <option v-for="country in countryOptions" :key="country.name" :value="country.name">
              {{ country.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="State/Province" class="w-full md:w-1/2 px-5">
          <d-select v-model="thirdAdditionalCompanyState" expanded required>
            <option value="" disabled>
              Select a State
            </option>
            <option v-for="state in availableStateOptions" :key="state.name" :value="state.abbreviation">
              {{ state.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="Email" class="w-full px-5">
          <d-input v-model="thirdAdditionalCompanyEmail" aria-label="email" type="email" />
        </d-field>
        <d-field label="Fax" class="w-full px-5">
          <d-input v-model="thirdAdditionalCompanyFax" aria-label="Fax number" />
        </d-field>
      </div>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { QUALIFY_CREDENTIALS_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions, mapGetters } = createNamespacedHelpers('qualifyCredentialsForm');

  export default {
    computed: {
      ...mapFields({
        fields: ['thirdAdditionalTypeOfRecipient', 'thirdAdditionalContactTitle', 'thirdAdditionalFirstName', 'thirdAdditionalContactLastName', 'thirdAdditionalCompanyName', 'thirdAdditionalAddressLineOne', 'thirdAdditionalAddressLineTwo', 'thirdAdditionalCompanyCity', 'thirdAdditionalCompanyCountry', 'thirdAdditionalCompanyState', 'thirdAdditionalCompanyZip', 'thirdAdditionalCompanyEmail', 'thirdAdditionalCompanyFax'],
        module: 'qualifyCredentialsForm',
        base: 'formFields',
        mutation: QUALIFY_CREDENTIALS_FORM.FORM_FIELDS,
      }),

      ...mapGetters([
        'countryOptions',
        'stateProvinceOptions',
      ]),

      availableStateOptions() {
        return this.stateProvinceOptions(this.thirdAdditionalCompanyCountry);
      },
    },

    watch: {
      thirdAdditionalCompanyCountry() {
        this.thirdAdditionalCompanyState = '';
      },
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>